import { NgModule } from '@angular/core';
import { AuthFactoryService } from '../auth/authFactory.service';
import { CancellationService } from '../cancellation/services/cancellation.service';
import { DashboardService } from '../dashboard/services/dashboard.service';
import { ItineraryService } from '../search-result/services/itinerary.service';
import { OperationLogService } from '../search-result/services/operation-log.service';
import { SpecialRequestService } from '../special-requests/services/special-request.service';
import { VoluntaryChangeService } from '../voluntary-change/services/voluntary-change.service';
import { TpTravelService } from './api/tptravel.service';
import { APIService } from './api/general.service';
import { ArrayHelpersService } from './services/array-helper.service';
import { TicketHistoryService } from '../search-result/services/ticket-history.service';
import { ItineraryHistoryService } from '../search-result/services/itinerary-history.service';
import { ReissueService } from '../reissue/services/reissue.service';
import { InfantControlService } from '../search-result/services/infant-control.service';
import { ReRouteService } from '../re-route/services/re-route.service';

@NgModule({
  declarations: [],
  providers: [
    APIService,
    TpTravelService,
    ItineraryService,
    DashboardService,
    OperationLogService,
    CancellationService,
    SpecialRequestService,
    VoluntaryChangeService,
    AuthFactoryService,
    ArrayHelpersService,
    TicketHistoryService,
    ItineraryHistoryService,
    ReissueService,
    InfantControlService,
    ReRouteService
  ]
})
export class CoreModule {}
